import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import type { TUnitConverterOptionsWithoutUnits, TUnitConverterTypicalReturn } from '../types'

export const grapePowderyMildew: Record<
  'grapePowderyMildew',
  (
    grapePowderyMildewAmount?: number | null,
    options?: TUnitConverterOptionsWithoutUnits,
  ) => TUnitConverterTypicalReturn
> = {
  grapePowderyMildew: (
    grapePowderyMildew: number | null = null,
    {
      decimalPlaces,
    }: {
      decimalPlaces?: number
    } = {},
  ) => {
    const defaultNumberOfDecimalPlaces = 0

    let convertedValue: number | null

    if (isNil(grapePowderyMildew)) {
      convertedValue = null
    } else {
      convertedValue = Number(grapePowderyMildew)
    }

    const decimalPlacesToUse = decimalPlaces ?? defaultNumberOfDecimalPlaces
    const categoryTitle = translate.phrases.banyanApp('Grape Powdery Mildew')

    const label = translate.phrases.banyanApp('{{diseaseName}} Secondary Infection Risk Index', {
      diseaseName: categoryTitle,
    })

    return {
      categoryTitle: () => categoryTitle,
      categoryTitleWithoutUnit: () => label,
      defaultNumberOfDecimalPlaces: () => defaultNumberOfDecimalPlaces,
      suffix: () => '',
      shortTitle: () => categoryTitle,
      title: () => label,
      titleWithoutUnit: () => label,
      value: () => {
        if (isNil(convertedValue)) return null

        return +convertedValue?.toFixed(decimalPlacesToUse)
      },
      valueAsString: () => {
        if (isNil(convertedValue)) return translate.phrases.templates('-')

        return convertedValue?.toFixed(decimalPlacesToUse)
      },
      valueWithSuffix: () =>
        translate.measurements.diseaseSeverityValue.value(convertedValue, decimalPlacesToUse),
      valueWithNoRounding: () => convertedValue,
    }
  },
}
